import {useState} from 'react'

import {ChevronDownIcon} from '@primer/octicons-react'
import {Stack, Text} from '@primer/react-brand'

import type {CopilotFeature} from '../../../../../brand/lib/types/contentful'
import {
  PLAN_TYPES,
  type PlanType,
} from '../../../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'

import {CompareTableRow} from './CompareTableRow'

type Props = {
  heading: string
  rows: CopilotFeature[]
  planType: PlanType
  htmlId?: string
}

export function CompareTableGroup(props: Props) {
  const {heading, rows, planType, htmlId} = props

  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Stack
      role="rowgroup"
      direction="vertical"
      gap="none"
      padding="none"
      className={isExpanded ? 'expanded' : ''}
      id={htmlId}
    >
      <div role="row">
        <div role="cell" className="mt-0 tmp-mt-md-5 tmp-pb-4 tmp-pb-md-3 d-none d-md-block">
          <Text size="300" weight="medium">
            {heading}
          </Text>
        </div>

        <div role="cell" className="d-md-none">
          <button
            type="button"
            aria-expanded={isExpanded}
            /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
            className="position-relative text-semibold width-full lp-Pricing-features-toggle-btn border-bottom mt-0 tmp-mt-md-5 tmp-pb-4 tmp-pb-md-3"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
            <Text size="300" weight="semibold" className="events-none">
              {heading}

              {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
              <div className="lp-Pricing-features-icon position-absolute top-0 right-0 d-md-none">
                <ChevronDownIcon />
              </div>
            </Text>
          </button>
        </div>
      </div>

      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      <div className="lp-Pricing-features-box">
        {rows.map(row => (
          <CompareTableRow
            key={row.sys.id}
            contentfulContent={row}
            showFree={planType === PLAN_TYPES.Individual}
            showPro={planType === PLAN_TYPES.Individual}
            showProPlus={planType === PLAN_TYPES.Individual}
            showMax={planType === PLAN_TYPES.Individual}
            showBusiness={planType === PLAN_TYPES.Business}
            showEnterprise={planType === PLAN_TYPES.Business}
          />
        ))}
      </div>
    </Stack>
  )
}
